import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-emerald-950 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="0.5"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-2 space-y-6">
            <img 
              src="https://static.readdy.ai/image/2315105bcc52647a42d8293f39d3fb09/a399ce152c5c62654fa82e31632c27dd.png" 
              alt="Logo"
              className="h-16 w-auto object-contain brightness-0 invert"
            />
            
            <p className="text-2xl font-serif leading-relaxed text-white/90">
              Energía inteligente<br />para tu hogar
            </p>

            <div className="flex gap-3">
              <input
                type="email"
                placeholder="Tu email"
                className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-lg outline-none focus:border-emerald-400 transition-colors text-white placeholder-white/60"
              />
              <button className="w-12 h-12 bg-emerald-500 hover:bg-emerald-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-notification-line text-xl text-white"></i>
              </button>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Servicios</h3>
            <ul className="space-y-3">
              <li><Link to="/servicios-luz" className="text-white/80 hover:text-white transition-colors cursor-pointer">Luz</Link></li>
              <li><Link to="/servicios-gas" className="text-white/80 hover:text-white transition-colors cursor-pointer">Gas</Link></li>
              <li><a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">Dual</a></li>
              <li><Link to="/empresas" className="text-white/80 hover:text-white transition-colors cursor-pointer">Empresas</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Recursos</h3>
            <ul className="space-y-3">
              <li><Link to="/subir-factura" className="text-white/80 hover:text-white transition-colors cursor-pointer">Calculadora</Link></li>
              <li><Link to="/blog" className="text-white/80 hover:text-white transition-colors cursor-pointer">Blog</Link></li>
              <li><a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">Guías</a></li>
              <li><a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">FAQs</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li>
                <a href="tel:+34696237625" className="text-white/80 hover:text-white transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  696 237 625
                </a>
              </li>
              <li>
                <a href="mailto:info@descuentosenluz.com" className="text-white/80 hover:text-white transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  info@descuentosenluz.com
                </a>
              </li>
              <li>
                <a href="https://wa.me/34696237625" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-whatsapp-line"></i>
                  WhatsApp 696237625
                </a>
              </li>
              <li className="text-white/80 flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>Granada, España</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/60">
              © 2025 Todos los derechos reservados
            </p>

            <div className="flex gap-4">
              <a href="https://www.linkedin.com/in/jose-maria-chema-mu%C3%B1oz-martin-25a83644/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/20 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="https://www.instagram.com/descuentosenluz/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/20 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://www.facebook.com/descuentosenluz" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/20 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://share.google/IoDZpA29FjisUGSit" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/20 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className="ri-map-pin-line text-lg"></i>
              </a>
            </div>

            <div className="flex gap-6 text-sm">
              <a href="#" className="text-white/60 hover:text-white transition-colors cursor-pointer">Privacidad</a>
              <a href="#" className="text-white/60 hover:text-white transition-colors cursor-pointer">Cookies</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors cursor-pointer">Website Builder</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}